"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "piegaro": {
    "ff6ee824": [{
      "hkey": "c8e61cf7",
      "slug": "piegaro",
      "name": "Piegaro",
      "primary": true,
      "skipSearch": false
    }],
    "cibottola": [{
      "hkey": "c8e61cf7",
      "slug": "piegaro",
      "name": "Piegaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba4da804": [{
      "hkey": "c8e61cf7",
      "slug": "piegaro",
      "name": "Piegaro",
      "primary": true,
      "skipSearch": false
    }],
    "gaiche": [{
      "hkey": "c8e61cf7",
      "slug": "piegaro",
      "name": "Piegaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "966ec10a": [{
      "hkey": "c8e61cf7",
      "slug": "piegaro",
      "name": "Piegaro",
      "primary": true,
      "skipSearch": false
    }],
    "ierna": [{
      "hkey": "c8e61cf7",
      "slug": "piegaro",
      "name": "Piegaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "71dc53c0": [{
      "hkey": "76324a4a",
      "slug": "oro-vincenze-ginestreto",
      "name": "Oro-Vincenze-Ginestreto",
      "primary": true,
      "skipSearch": false
    }],
    "oro": [{
      "hkey": "76324a4a",
      "slug": "oro-vincenze-ginestreto",
      "name": "Oro-Vincenze-Ginestreto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c86fdea8": [{
      "hkey": "ebfb9c14",
      "slug": "ponibbiale-pratalenza",
      "name": "Ponibbiale-Pratalenza",
      "primary": true,
      "skipSearch": false
    }],
    "pratalenza": [{
      "hkey": "ebfb9c14",
      "slug": "ponibbiale-pratalenza",
      "name": "Ponibbiale-Pratalenza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "47a4962c": [{
      "hkey": "82c3975c",
      "slug": "castiglion-fosco-collebaldo",
      "name": "Castiglion Fosco-Collebaldo",
      "primary": true,
      "skipSearch": false
    }],
    "castiglion-fosco": [{
      "hkey": "82c3975c",
      "slug": "castiglion-fosco-collebaldo",
      "name": "Castiglion Fosco-Collebaldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cc6e1353": [{
      "hkey": "82c3975c",
      "slug": "castiglion-fosco-collebaldo",
      "name": "Castiglion Fosco-Collebaldo",
      "primary": true,
      "skipSearch": false
    }],
    "colle-baldo": [{
      "hkey": "82c3975c",
      "slug": "castiglion-fosco-collebaldo",
      "name": "Castiglion Fosco-Collebaldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cbca4984": [{
      "hkey": "82c3975c",
      "slug": "castiglion-fosco-collebaldo",
      "name": "Castiglion Fosco-Collebaldo",
      "primary": true,
      "skipSearch": false
    }],
    "collebaldo": [{
      "hkey": "82c3975c",
      "slug": "castiglion-fosco-collebaldo",
      "name": "Castiglion Fosco-Collebaldo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;